import React from "react";

export interface ProjectFilePreviewModalData {
  name: string;
  previewUrl: string;
  href: string;
  sizeLabel?: string;
  dateLabel?: string;
}

interface ProjectFilePreviewModalProps {
  data: ProjectFilePreviewModalData | null;
  onClose: () => void;
  onDownload: () => void;
}

function ProjectFilePreviewImage({ src, alt }: { src: string; alt: string }) {
  const [failed, setFailed] = React.useState(false);
  if (!src || failed) {
    return (
      <div className="pq-file-preview-fallback">
        <i className="ri-image-line" aria-hidden />
        <p>Preview not available for this file type.</p>
      </div>
    );
  }
  return (
    <img
      className="pq-file-preview-img"
      src={src}
      alt={alt}
      onError={() => setFailed(true)}
    />
  );
}

export default function ProjectFilePreviewModal({
  data,
  onClose,
  onDownload,
}: ProjectFilePreviewModalProps) {
  if (!data) return null;
  return (
    <div className="pq-file-preview-backdrop" role="presentation" onClick={onClose}>
      <div
        className="pq-file-preview-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="pq-file-preview-title-shared"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="pq-file-preview-head">
          <div className="pq-file-preview-title-wrap">
            <i className="ri-file-2-line" aria-hidden />
            <h2 id="pq-file-preview-title-shared" className="pq-file-preview-title">
              {data.name}
            </h2>
          </div>
          <button
            type="button"
            className="pq-file-preview-close"
            aria-label="Close preview"
            onClick={onClose}
          >
            <i className="ri-close-line" />
          </button>
        </div>
        <div className="pq-file-preview-body">
          {data.previewUrl ? (
            <ProjectFilePreviewImage src={data.previewUrl} alt={data.name} />
          ) : (
            <div className="pq-file-preview-fallback">
              <i className="ri-file-line" aria-hidden />
              <p>Preview not available for this file type.</p>
            </div>
          )}
        </div>
        <div className="pq-file-preview-foot">
          <span className="pq-file-preview-meta">
            {data.sizeLabel || "—"} · {data.dateLabel || "—"}
          </span>
          <button type="button" className="pq-file-preview-download" onClick={onDownload}>
            <i className="ri-download-line" />
            Download
          </button>
        </div>
      </div>
    </div>
  );
}

